/* External dependencies */
import React, { useState } from 'react';
import { connect } from 'react-redux';
import get from 'lodash/get';

/* Internal dependencies */
import Icon, { Icons } from '../icon/Icon';
import { ProfileType } from '../types/Profile';
import { ApplicationState } from '../store';
import { CurrentProfileState, getCurrentProfile } from '../store/ducks/currentProfile';
import DrawerButton from 'src/drawer/DrawerButton';

type OwnProps = {
  profile: ProfileType;
  size: number;
  style?: Object;
  disabled?: boolean;
};

type StateProps = {
  currentProfile: CurrentProfileState;
};

type Props = OwnProps & StateProps;

const Verified: React.FC<Props> = ({
  currentProfile,
  profile,
  size = 20,
  style = {},
  disabled = false,
}) => {
  const [drawerOpen, setDrawerOpen] = useState<boolean>(false);
  const currentProfileId = get(currentProfile, 'id');
  const profileId = get(profile, 'id');
  const profileName = get(profile, 'name');
  const profileVerified = get(profile, 'verified', false);
  const defaultDescription = 'Verified accounts have purple checkmarks next to their names to show that Beatmatch has confirmed they\'re the real presence of the public figures, influencers, and people they represent.';

  if (!profileVerified) return null;

  return (
    <DrawerButton
      open={drawerOpen}
      openDrawer={() => { setDrawerOpen(true); }}
      closeDrawer={() => { setDrawerOpen(false); }}
      content={(
        <div className="d-flex flex-column justify-content-center align-items-center pt-4">
          <div
            className="bg-secondaryButton d-flex flex-column justify-content-center align-items-center mb-4"
            style={{
              width: 75,
              aspectRatio: '1',
              borderRadius: 50,
            }}
          >
            <Icon name={Icons.verified} className="bm-Text--primary" size={28} solid />
          </div>
          <h3 className="text-bold text-center mb-4">
            Verified Profile
          </h3>
          <h5 className="text-center">
            <h5 className="text-bold text-center">
              {`${profileId === currentProfileId ? 'Your profile' : `${profileName}`}`}
            </h5>
            {` is a verified profile. ${defaultDescription}`}
          </h5>
        </div>
      )}
      render={(onClick) => (
        <button
          className="btn m-0 p-0 ml-1"
          onClick={onClick}
          disabled={disabled}
        >
          <Icon
            name={Icons.verified}
            className="bm-Icon--primary"
            size={size}
            solid
            style={style}
          />
        </button>
      )}
    />
  );
};

const mapStateToProps = (state: ApplicationState) => ({
  currentProfile: getCurrentProfile(state)
});

export default connect(mapStateToProps)(Verified);